import * as React from 'react'
import SelectSearch from 'react-select-search';
import ScrollableAnchor from 'react-scrollable-anchor'
import { goToAnchor, configureAnchors  } from 'react-scrollable-anchor'

class Sections extends React.Component {

    constructor(props) {
        super(props);

        const dataOption = props.cmsData.note.subject.map((item) => {
            let { subject_value, subject_label, _id } = item
            return {name: subject_label, value: subject_value};
        })

        this.state = {
            dataOption: dataOption,
            particulars: {
                youAddress: {
                    gender: '',
                    firstName: '',
                    lastName: '',
                },
                youContact: {
                    email: '',
                    phone: '',
                },
            },
            leaveANote: {
                subjectName: '',
                subject: '',
                message: ''
            },
            formRedirect: props.cmsData.formRedirect,
            isAgreePolicy: false,
            error: {}
        }
    }

    onYouAddressChanged = (e) => {
        let fieldName = e.currentTarget.name;
        let value = e.currentTarget.value;

        this.setState(prevState => {
            let youAddress = {
                ...prevState.particulars.youAddress
            }

            youAddress[fieldName] = value;
            
            return {
                particulars: {
                    ...prevState.particulars,
                    youAddress: youAddress
                }
            }
        }, function() {
            this.validate(false, fieldName)
        });
    }

    formatNumber = (n) => {
        let formated = n.replace(/\D/g, "");
        return formated;
    }

    getPhone = () => {
      return this.formatNumber(this.state.particulars.youContact.phone);
    }

    onYouContactChanged = (e) => {
        let fieldName = e.currentTarget.name;
        let value = e.currentTarget.value;

        this.setState(prevState => {
            let youContact = {
                ...prevState.particulars.youContact
            }

            youContact[fieldName] = value;
            
            return {
                particulars: {
                    ...prevState.particulars,
                    youContact: youContact
                }
            }
        }, function() {
            this.validate(false, fieldName)
        });
    }

    onSubjectMessageChanged = (e) => {
        let value = e.currentTarget.value;

        this.setState(prevState => {
            return {
                leaveANote: {
                    ...prevState.leaveANote,
                    message: value
                }
            }
        }, function() {
            this.validate(false, 'message')
        });
    }

    onSubjectChanged = (value) => {
        let currentSubject = this.state.dataOption.filter(function (e) {
            return e.value == value;
        });
        let subjectName = currentSubject && currentSubject.length > 0 ? currentSubject[0].name : '';

        this.setState(prevState => {
            return {
                leaveANote: {
                    ...prevState.leaveANote,
                    subject: value,
                    subjectName: subjectName
                }
            }
        }, function() {
            this.validate(false, 'subject')
        });
    }

    onAgreeChanged = (e) => {
        let checked = e.currentTarget.checked;

        this.setState(prevState => {
            return {
                isAgreePolicy: checked
            }
        });
    }

    itemValidate = (name, isSubmit, inputField, message) => {
        if( ((!isSubmit && inputField == name) || isSubmit) ) {
            if(particulars.youAddress.gender === '' ) {
                error[name] = message;
            }
            else {
                delete error[name];
            }
        }
    } 

    validate = (isSubmit = false, fieldName) => {
        // let error = {};
        let {particulars, leaveANote, error} = this.state;
        'Please select a title'

        // this.itemValidate('gender', isSubmit, fieldName, 'Please select a title');
        // this.itemValidate('firstName', isSubmit, fieldName, 'Please fill in your first name');

        if( ((!isSubmit && fieldName == 'gender') || isSubmit) ) {
            if(particulars.youAddress.gender === '' ) {
                error['gender'] = 'Please select a title';
            }
            else {
                delete error['gender'];
            }
        }
        if( ((!isSubmit && fieldName == 'firstName') || isSubmit) ) {
            if( particulars.youAddress.firstName == '' ) {
                error['firstName'] = 'Please fill in your first name';
            }
            else {
                delete error['firstName'];
            }
        }
        if( ((!isSubmit && fieldName == 'lastName') || isSubmit) ) {
            if( particulars.youAddress.lastName == '' ) {
                error['lastName'] = 'Please fill in your last name';
            }
            else {
                delete error['lastName'];
            }
        }
        if( ((!isSubmit && fieldName == 'email') || isSubmit) ) {
            if( particulars.youContact.email == '' ) {
                error['email'] = 'Please fill in your email address';
            }
            else if( particulars.youContact.email != '' && !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(particulars.youContact.email)) {
                error['email'] = 'Please fill in a valid email address';
            }
            else {
                delete error['email'];
            }
        }
        if( ((!isSubmit && fieldName == 'phone') || isSubmit) ) {
            if( particulars.youContact.phone == '' ) {
                error['phone'] = 'Please fill in your mobile number';
            }
            else if( particulars.youContact.phone != '' && (particulars.youContact.phone.length < 7 || ![8,9].includes(Number(particulars.youContact.phone[0]))) ) {
                error['phone'] = 'Please fill in a valid mobile number';
            }
            else {
                delete error['phone'];
            }
        }
        
        if( ((!isSubmit && fieldName == 'subject') || isSubmit) ) {
            if( leaveANote.subject == '' ) {
                error['subject'] = 'Please select a subject';
            }
            else {
                delete error['subject'];
            }
        }
        if( ((!isSubmit && fieldName == 'message') || isSubmit) ) {
            if( leaveANote.message == '' ) {
                error['message'] = 'Please describe your enquiry';
            }
            else {
                delete error['message'];
            }
        }

        this.setState({
            error: error
        })

        return error;
    }

    saveLocalStorage(obj, key) {    
        localStorage.removeItem(key);

        var jsonData = JSON.stringify(obj);
        localStorage.setItem(key, jsonData);
    }

    onSubmit = (e) => {
        let mapSection = {
            address: ['gender','firstName','lastName'],
            contact: ['email','phone'],
            note: ['subject','message']
        }
        let errors = this.validate(true);
        if( !jQuery.isEmptyObject(errors) ) {
            let target = ''

            for(const index in errors) {
                if(mapSection.address.includes(index)) {
                    target = 'address';
                }
                else if(target != 'address' && mapSection.contact.includes(index)) {
                    target = 'contact';
                }
                else if(target != 'address' && target != 'contact' && mapSection.note.includes(index)) {
                    target = 'note';
                }
            }

            configureAnchors({offset: -150, scrollDuration: 500})
            goToAnchor(`error-${target}`, true)

            return
        }

        let {particulars, leaveANote, isAgreePolicy, formRedirect} = this.state;
        let jsonBody = {
            "fields": [
              {
                "name": "salutation",
                "value": particulars.youAddress.gender
              },
              {
                "name": "email",
                "value": particulars.youContact.email
              },
              {
                "name": "firstname",
                "value": particulars.youAddress.firstName
              },
              {
                "name": "lastname",
                "value": particulars.youAddress.lastName
              },
              {
                "name": "message_subject",
                "value": leaveANote.subjectName
              },
              {
                "name": "message",
                "value": leaveANote.message
              },
              {
                "name": "phone",
                "value":  particulars.youContact.phone
              },
              {
                "name": "consent_agreement",
                "value": isAgreePolicy
              }
            ]
        };
        let url = 'https://api.hsforms.com/submissions/v3/integration/submit/8357376/147d9b37-fd3c-4139-9038-cf4878f00fa5';
        return fetch( url,
                {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    body: JSON.stringify(jsonBody),
                }
            )
            .then((response) => {
                if(response.status == 200 && response.ok) {
                    this.saveLocalStorage({ particulars, leaveANote }, 'contact-form-submiting');
                    window.location.href = formRedirect;
                }
                
                return response.json();
            })
            .then((data) => {
                if(data.status && data.status == 'error' && data.errors[0].errorType == 'INVALID_EMAIL') {
                    this.setState(prevState => {
                        let error = prevState.error;
                        error['email'] = 'Please fill in a valid email address';
                        return {
                            error: error
                        }
                    }, function() {
                        configureAnchors({offset: -150, scrollDuration: 500})
                        goToAnchor('error-contact', true)
                    });
                }
            })
            .catch(function(error) {
                console.log('There has been a problem with your fetch operation: ' + error.message);
            });
    }

    render() {
        let { cmsData } = this.props;
        let { error } = this.state;

        const ItemsGender = cmsData.particulars.address.gender.map((item) => {
            let { address_gender_value, address_gender_label, _id } = item
            return (
                 <label className="ecf-contact-us__choose__item" key={`gender-item${_id}`}>
                    <input type="radio" name="gender" onChange={this.onYouAddressChanged} value={address_gender_value} />
                    <span className="ecf-contact-us__choose__item__bg"></span>
                    <span className="ecf-contact-us__choose__item__text">{address_gender_label}</span>
                </label>
            )
        })
       
        return (
            <>
                <div className="row">
                    <div className="col-12 col-lg-6 pl-lg-6">
                        <div className="ecf-contact-us__offset-box__particular">
                            <h5>{cmsData.particulars.title}</h5>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 pr-lg-6">
                        <ScrollableAnchor id={'error-address'}>
                            <div className="ecf-contact-us__address-you">
                                <div className="ecf-contact-us__body-b1">
                                    {cmsData.particulars.address.title}
                                </div>
                                    <div>
                                        <div className="ecf-contact-us__choose">
                                            { ItemsGender }
                                        </div>
                                        {
                                            error && error.gender &&
                                            <div className="ecf-contact-us__error" >{error.gender}</div>
                                        }
                                    </div>
                                    <div className="ecf-contact-us__input">
                                        <input name="firstName" type="text" placeholder={cmsData.particulars.address.firstname_placeholder} onChange={this.onYouAddressChanged}/>
                                        {
                                            error && error.firstName &&
                                            <div className="ecf-contact-us__error" >{error.firstName}</div>
                                        }
                                    </div>
                                    <div className="ecf-contact-us__input">
                                        <input name="lastName" type="text" placeholder={cmsData.particulars.address.lastname_placeholder} onChange={this.onYouAddressChanged}/>
                                        {
                                            error && error.lastName &&
                                            <div className="ecf-contact-us__error" >{error.lastName}</div>
                                        }
                                    </div>
                            </div>
                        </ScrollableAnchor>
                        <ScrollableAnchor id={'error-contact'}>
                            <div className="ecf-contact-us__contact-you">
                                <div className="ecf-contact-us__body-b1">
                                    {cmsData.particulars.contact.title}
                                </div>
                                <div className="ecf-contact-us__input">
                                        <input name="email" type="text" placeholder={cmsData.particulars.contact.email_placeholder} onChange={this.onYouContactChanged} />
                                    
                                    {
                                        error && error.email &&
                                        <div className="ecf-contact-us__error" >{error.email}</div>
                                    }
                                </div>
                                <div className="ecf-contact-us__input">
                                    <input value={this.getPhone()}
                                    name="phone" type="text" maxLength="8" placeholder={cmsData.particulars.contact.phone_placeholder} onChange={this.onYouContactChanged} />
                                    {
                                        error && error.phone &&
                                        <div className="ecf-contact-us__error" >{error.phone}</div>
                                    }
                                </div>
                            </div>
                        </ScrollableAnchor>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 px-lg-6">
                        <div className="ecf-contact-us__line"></div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-lg-6 pl-lg-6">
                        <div className="ecf-contact-us__offset-box__particular">
                            <h5>{cmsData.note.title}</h5>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 pr-lg-6">
                        <div className="ecf-contact-us__address-you">
                            <ScrollableAnchor id={'error-note'}>
                                <div className="ecf-contact-us__body-b1">
                                    {cmsData.note.subtitle}
                                </div>
                            </ScrollableAnchor>
                                <div className="ecf-contact-us__select">
                                <SelectSearch 
                                    value = ""
                                    options = {this.state.dataOption}
                                    placeholder={cmsData.note.subject_placeholder}
                                    onChange={this.onSubjectChanged}
                                />
                                </div>
                                {
                                    error && error.subject &&
                                    <div className="ecf-contact-us__error" >{error.subject}</div>
                                }
                                <div className="ecf-contact-us__textarea">
                                    <textarea rows="5" placeholder={cmsData.note.message_placeholder} onChange={this.onSubjectMessageChanged}></textarea>
                                    {
                                        error && error.message &&
                                        <div className="ecf-contact-us__error" >{error.message}</div>
                                    }
                                </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 px-lg-6">
                        <div className="ecf-contact-us__note" dangerouslySetInnerHTML={{__html: cmsData.policy.policy_content}}>
                        </div>
                        <div className="ecf-contact-us__policy-check-box mt-32">
                            <input
                                name="agreeReceve"
                                type="checkbox"
                                id="agreeReceve"
                                // value="yes"
                                // checked={this.state.isGoing}
                                onChange={this.onAgreeChanged} 
                            />
                            <label htmlFor="agreeReceve" >
                                <span>
                                    {cmsData.policy.policy_agree}
                                </span>
                            </label>
                        </div>
                        {/* {
                            error && error.isAgreePolicy &&
                            <div className="ecf-contact-us__error" >{error.isAgreePolicy}</div>
                        } */}
                        <div className="ecf-contact-us__policy-button">
                            <button
                                className="ecf-btn ecf-btn-primary"
                                aria-label="donate-submit-button"
                                onClick={this.onSubmit}
                            >
                                {cmsData.policy.submit_button}
                            </button>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default Sections;